import "./App.css";
import AssetsStepperComp from "./components/AssetsStepperComp.js";
import Home from "./Pages/Home.js";
import SearchPage from "./Pages/SearchPage.js";
import DetailsPage from "./Pages/DetailsPage.js";
import MyFleet from "./Pages/MyFleet.js";
import Contact from "./Pages/ContactUs.js";
import NotFound from "./Pages/NotFound";
// Client Pages
import Login from "./Pages/ClientAuth/Login";
import Register from "./Pages/ClientAuth/Register";
import Forgot from "./Pages/ClientAuth/Forgot";
// Broker Auth
import BrokerLogin from "./Pages/BrokerAuth/Login";
import BrokerRegister from "./Pages/BrokerAuth/Register";
import BrokerForgot from "./Pages/BrokerAuth/Forgot";

import Header from "./components/Header.js";
import Footer from "./components/Footer";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/yacht/details" element={<DetailsPage />} />
          <Route
            path="assets"
            element={
              <>
                <Header />
                <AssetsStepperComp />
                <Footer />
              </>
            }
          />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/myfleet" element={<MyFleet />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
          {/* Client auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot" element={<Forgot />} />
          {/* Broker auth */}
          <Route path="/broker/login" element={<BrokerLogin />} />
          <Route path="/broker/register" element={<BrokerRegister />} />
          <Route path="/broker/forgot" element={<BrokerForgot />} />
        </Routes>
      </Router>
      {/* <AssetsStepperComp /> */}
    </div>
  );
}

export default App;
